<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container grid-list-md>
    <v-layout justify-center align-center>
      <v-flex :class="{ md10: standalone, md12: !standalone }">
        <eimza-gate title="Tekil Numaraya SMS" :auto-open-pin="standalone">
          <v-card-text>
            <v-alert style="overflow-x: auto" type="warning">
              <span>
                HATIRLATMA!
                <br>
                Ticari SMS içeriklerinde;
                firmalar için Mersis No, şahıs işletmelerinde ise;
                Ad Soyad ve TC.Kimlik Numarası, telefon veya email gibi iletişim bilgisinin
                RET Hizmeti ile birlikte bulunması önem teşkil etmektedir.
              </span>
            </v-alert>
            <v-form ref="form" lazy-validation>
              <v-layout row justify-center align-center>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs12 sm4>
                      <v-flex xs12>
                        <v-text-field
                          v-model="sendData.numbers"
                          v-mask="'0(###) ### ## ##'"
                          :rules="[$rules.required({ falseValues: [''], message: 'Telefon Numarası alanı boş olamaz!' })]"
                          @input="sendData.numbers = $mask.unmasked(sendData.numbers)"
                          label="Alıcı Telefon Numarası"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <senders-or-message-types
                          label="Gönderici Adları"
                          required
                          no-data-text="Aktif Gönderici Adı bulunmuyor"
                          :default="senders[0]"
                          :rules="[$rules.required({ falseValues: [undefined, null], message: 'Gönderici adı seçimi yapmalısınız' })]"
                          :items="data.senders"
                          @on:model-update="(val) => { sendData.sender = val; }"
                        ></senders-or-message-types>
                      </v-flex>
                      <v-flex xs12>
                        <senders-or-message-types
                          label="Tür"
                          required
                          :items="types"
                          :rules="[$rules.required({ falseValues: [undefined, null], message: 'Mesaj türü seçimi yapmalısınız' })]"
                          :default="data.default_message_type"
                          item-text="text"
                          item-value="value"
                          @on:model-update="(val) => { sendData.message_type = val; }"
                        ></senders-or-message-types>
                      </v-flex>
                      <v-flex xs12>
                        <template-selector
                          label="Şablon Seçinizi"
                          :items="data.templates"
                          @on:template-selected="(val) => { msgBox = val.content; }"
                        ></template-selector>
                      </v-flex>
                      <v-flex xs12>
                        <time-type
                          :rules="[$rules.required({ falseValues: [undefined, null], message: 'Gönderim zamanı seçimi yapmalısınız' })]"
                          @type:update="(val) => (wTimeStat = val)"
                        ></time-type>
                      </v-flex>
                      <v-flex xs12 v-if="wTimeStat">
                        <date-month-picker
                          label="Gönderme Tarihi"
                          :disable-prev="true"
                          :rules="[$rules.required({ falseValues: [''], message: 'Tarih seçimi yapmalısınız' })]"
                          @on:date-selected="(val) => { date = val; dateSelected = true; }"
                        ></date-month-picker>
                      </v-flex>
                      <v-flex xs12 v-if="wTimeStat">
                        <time-picker
                          label="Gönderme Saati"
                          :valid="dateSelected"
                          :rules="[$rules.empty('Gönderme Saati')]"
                          @on:time-selected="(val) => { time = ` ${val}:00`; }"
                        ></time-picker>
                      </v-flex>
                      <v-flex xs12>
                        <message-type @type="(val) => (message_content_type = val)"></message-type>
                      </v-flex>
                    </v-flex>
                    <v-flex xs12 sm8>
                      <v-flex xs12>
                        <button-keys
                          :keys="data.keys"
                          item-value="value"
                          @on:button-key="(val) => { this.msgBox += ` ${val}`; }"
                        ></button-keys>
                      </v-flex>
                      <v-flex xs12>
                        <sms-message
                          label="Mesajınızı bu alana giriniz"
                          required
                          :rows="'18'"
                          :rules="[
                            $rules.empty('Mesaj'),
                            (v) => sendData.message_type === 'turkce' ? v.length <= 877 || 'Maksimum karakter sayısı 882 olabilir.' : sendData.message_type === 'normal' || true,
                          ]"
                          :value="msgBox"
                          :c-message="msgBox"
                          :c-type="sendData.message_type"
                          @text:change="textChange"
                        ></sms-message>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex>
                  <sms-confirmation
                    :context="confirmation.context"
                    :valid="confirmation.valid"
                    @on:disagree="() => { $trigger('setPluginDialog'); confirmation.valid = !confirmation.valid; }"
                    @on:agree="sendMessage"
                  >
                    <template v-slot:activator>
                      <v-btn color="primary" block @click="smsPreview">
                        Mesajı Gönder <v-icon right dark>mdi-send</v-icon>
                      </v-btn>
                    </template>
                  </sms-confirmation>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </eimza-gate>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { types } from '../../../misc';
import EimzaGate from '../../Components/EimzaGate.vue';
import SendersOrMessageTypes from '../../Components/SMSConstants/SendersOrMessageTypes.vue';
import TemplateSelector from '../../Components/SMSConstants/TemplateSelector.vue';
import DateMonthPicker from '../../Components/SMSConstants/DateMonthPicker.vue';
import TimePicker from '../../Components/SMSConstants/TimePicker.vue';
import TimeType from '../../Components/SMSConstants/TimeType.vue';
import SmsMessage from '../../Components/SMSConstants/SmsMessage.vue';
import ButtonKeys from '../../Components/SMSConstants/ButtonKeys.vue';
import SmsConfirmation from '../../Components/SMSConfirmation.vue';
import MessageType from '../../Components/SMSConstants/MessageType.vue';

export default {
  name: 'Number',
  components: {
    EimzaGate,
    SmsConfirmation,
    ButtonKeys,
    SmsMessage,
    TimeType,
    TimePicker,
    DateMonthPicker,
    TemplateSelector,
    SendersOrMessageTypes,
    MessageType,
  },
  props: {
    standalone: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    types,
    sendData: { message_type: '', numbers: '' },
    wTimeStat: false,
    date: '',
    time: '',
    dateSelected: false,
    data: {},
    confirmation: { valid: false, context: { examples: [] } },
    message: '',
    senders: [],
    message_content_type: null,
    isSmsMessageValid: false,
  }),
  computed: {
    msgBox: {
      get() { return this.message || ''; },
      set(newVal) { this.message = newVal; },
    },
  },
  created() {
    this.sendData.numbers = this.$mask.unmasked(this.$route.params.phone);
    const allowedKeys = ['İptal Linki', 'Kısa Kod'];
    this.send({ route: 'sms/number' }).then(async (res) => {
      this.data = await res.data.data;
      this.senders = res.data.data.senders;
      // eslint-disable-next-line prefer-destructuring
      this.sendData.sender = this.senders[0];
      this.sendData.message_type = this.data.default_message_type;
      this.data.keys = Object.filterByKey(allowedKeys, this.data.keys);
    });
  },
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    prepareSendData() {
      this.sendData.message = this.msgBox;
      this.sendData.send_time = this.date + this.time;
      this.sendData.numbers = this.sendData.numbers.substr(this.sendData.numbers.length - 10);
      this.sendData.message_content_type = this.message_content_type;
      if (!this.wTimeStat) delete this.sendData.send_time;
    },
    sendMessage() {
      this.route = 'sms/number/send';
      if (this.$refs.form.validate()) {
        this.prepareSendData();
        this.send({ route: this.route, data: this.sendData }).then(() => this.resetForm());
      }
    },
    smsPreview() {
      if (this.confirmation.valid) {
        this.confirmation.valid = false;
        this.$trigger('setPluginDialog');
      }
      this.confirmation.valid = this.$refs.form.validate();
      if (this.$refs.form.validate()) {
        this.prepareSendData();
        this.send({ route: 'sms/number/send/preview', data: this.sendData })
          .then((res) => { this.confirmation.context = res.data.data; });
      }
    },
    // eslint-disable-next-line spaced-comment
    textChange(val/*, messageCount*/) {
      this.msgBox = val;
    },
    resetForm() {
      this.$refs.form.reset();
    },
  },
};
</script>
